import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { zIndex } from 'constants/settings';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getRouteByUrl } from '../app/appActions';
//Page types
import { BasePage } from '../basepage';
import NotFoundPage from '../notfoundpage';
import { Route, Switch } from 'react-router-dom';
import queryString from 'query-string';

import { Transition } from 'react-transition-group';
import anime from 'animejs';

const enterDuration = 200;
const exitDuration = 100;

class PageRoutes extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      routes: null,
      loadedId: null,
      lastLoadedId: null,
      requestedUrl: '',
      requestProps: this.parseRequestProps(
        props.location && props.location.search ? props.location.search : ''
      )
    };
  }

  normalizePath = function(path) {
    const p = (path || '/').replace(/\/+$/, '');
    return p === '' ? '/' : p;
  };

  isEditorContext = () => {
    const p = (window.location.pathname || '').toLowerCase();
    return p.indexOf('/episerver/cms') > -1;
  };

  getCurrentPageIdFromDom = () => {
    const editRoot = document.getElementById('root-edit-mode');
    const root = document.getElementById('root');
    const id =
      (editRoot && editRoot.getAttribute('data-current-page-id')) ||
      (root && root.getAttribute('data-current-page-id')) ||
      '';
    return id ? Number(id) : null;
  };

  parseRequestProps = search => {
    const qs = new URLSearchParams(search || '');
    return {
      blockId: qs.get('blockId') || undefined,
      contentId: qs.get('contentId') ? Number(qs.get('contentId')) : undefined
    };
  };

  componentDidUpdate = prevProps => {
    var prevPath = this.normalizePath(prevProps.location && prevProps.location.pathname);
    var nextPath = this.normalizePath(this.props.location && this.props.location.pathname);

    if (prevPath !== nextPath) {
      if (this.state.requestedUrl !== nextPath) {
        this.setState({ requestedUrl: nextPath });
      }
    }

    const prevSearch = (prevProps.location && prevProps.location.search) || '';
    const nextSearch = (this.props.location && this.props.location.search) || '';
    if (prevSearch !== nextSearch) {
      const nextRequestProps = this.parseRequestProps(nextSearch);
      const curr = this.state.requestProps || {};
      if (
        curr.blockId !== nextRequestProps.blockId ||
        curr.contentId !== nextRequestProps.contentId
      ) {
        this.setState({ requestProps: nextRequestProps });
      }
    }

    const prevApp = prevProps.app;
    const app = this.props.app;
    const appRoutes = app.routes;
    const pageNotFound = app.pageNotFound;

    if (app.routes === prevApp.routes) return null;

    const routes = appRoutes.map(route => {
      const url = route.url;
      const id = route.id;
      const pageType = route.pageType;

      return url.map((linkUrl, i) => (
        <Route
          key={linkUrl + '_' + i}
          exact
          path={linkUrl}
          render={props => this.getPageType(pageType, id, linkUrl)}
        />
      ));
    });
    if (this.isEditorContext()) {
      // in preview/edit fallback: render through current-page-id in DOM
      routes.push(
        <Route
          key="editor_fallback"
          path="*"
          render={() => {
            const currentId = this.getCurrentPageIdFromDom();
            const route = (appRoutes || []).find(r => Number(r.id) === Number(currentId));
            if (!route) return null;
            return this.getPageType(route.pageType, route.id, (route.url && route.url[0]) || '');
          }}
        />
      );
    } else {
      routes.push([
        <Route
          key={'404_page'}
          path="*"
          render={route =>
            this.getPageType(pageNotFound.pageType, pageNotFound.id, pageNotFound.url[0])
          }
        />
      ]);
    }

    this.setState({
      routes: routes
    });
  };

  handlePageLoaded(id) {
    const { app, filter } = this.props;
    const { selected } = filter;
    const { routes: appRoutes } = app;
    this.setState({ lastLoadedId: this.state.loadedId, loadedId: id });
    const routeObj = appRoutes.filter(item => {
      return item.url[0] === window.location.pathname;
    });
    if (!routeObj.length) return;

    const county = queryString.parse(window.location.search);
    const isCountyMissing = Object.keys(county).length === 0;
    const isCountyChanged = county.region && county.region !== selected.name;
    const newUrl = determineNewUrl();

    if (newUrl !== null) {
      window.history.replaceState('', '', newUrl);
    }

    function determineNewUrl() {
      if (routeObj[0].hideCountyInUrl) {
        return routeObj[0].url[0];
      }

      if ((isCountyMissing || isCountyChanged) && selected.id !== 2) {
        return `?region=${selected.name.replace(/\s+/g, '')}`;
      }

      if (selected.id === 2 && routeObj[0].pageType !== 'SearchPage') {
        return routeObj[0].url[0];
      }

      return '';
    }
  }
  getPageType = (type, id, link = '') => {
    const { loadedId, requestedUrl, requestProps } = this.state;
    const { isHybridPage } = this.props;
    return (
      <Transition
        key={link}
        exit={true}
        enter={true}
        in={loadedId === id}
        appear={true}
        timeout={{ exit: exitDuration, enter: enterDuration }}
        onEnter={this.onEnter}
        onEntering={this.onEntering}
        onEntered={this.onEntered}
        onExit={this.onExit}
        onExiting={this.onExiting}
        onExited={this.onExiting}
        mountOnEnter={false}
        unmountOnExit={false}>
        <div key={link}>
          <BasePage
            key={id}
            first={true}
            onLoadedComplete={() => this.handlePageLoaded(id)}
            id={id}
            pagetype={type}
            requestedUrl={requestedUrl}
            requestProps={requestProps}
            isHybridPage={isHybridPage}
          />
        </div>
      </Transition>
    );
  };

  clearProps = node => {
    node.style.position = 'relative';
  };

  onEnter = (node, isAppearing) => {
    if (!node) return null;
    node.style.zIndex = zIndex.ABOVE_MODALS;
    node.style.background = 'white';
    node.style.opacity = 0;

    anime({
      duration: enterDuration,
      delay: 0,
      targets: node,
      translateZ: ['-.5rem', 0],
      opacity: [0.7, 1],
      elasticity: 1000,
      easing: 'easeInOutExpo',
      completed: this.clearProps(node)
    });
  };

  onEntering = (node, isAppearing) => {};

  onEntered = (node, isAppearing) => {};

  onExit = node => {
    if (!node) return null;
    node.style.position = 'fixed';
    node.style.top = 0;
    node.style.zIndex = zIndex.LEVEL_0;

    anime({
      duration: exitDuration,
      targets: node,
      opacity: {
        value: [1, 0],
        duration: exitDuration
      },
      scale: [1, 0.97],
      elasticity: 0,
      filter: 'blur(3px)',
      easing: 'easeInOutBack',
      complete: () => {
        this.clearProps(node);
      }
    });
  };

  onExiting = node => {};
  onExited = node => {};

  render() {
    const { location } = this.props;

    return (
      <Switch location={location}>
        {this.state.routes}
        <Route component={NotFoundPage} />
      </Switch>
    );
  }
}

const mapStateToProps = state => ({
  app: {
    routes: state.app.routes,
    pageNotFound: state.app.pageNotFound
  },
  page: {
    loading: state.page.loading,
    id: state.page.currentId
  },
  filter: {
    selected: state.filter.selected
  }
});

const mapDispatchToProps = dispatch => bindActionCreators({ getRouteByUrl }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PageRoutes);

PageRoutes.propTypes = {
  location: PropTypes.object.isRequired,
  pagetype: PropTypes.oneOf([
    'StandardPage',
    'StartPage',
    'CalendarPage',
    'TjanstePage',
    'RemissPage'
  ])
};
